'use client';

import { Scene7Image } from '../Scene7Image';
import type { LegacyIconProps } from './types';

export function LegacyIcon({ name, size, isPriority, className }: Readonly<LegacyIconProps>) {
    const iconSrc = `/icons/${name}.png`;
    // NOTE: Legacy icons are a mix between custom font icons with icomoon.io and png images.
    // As the legacy design is temporary, we don't want to invest time in creating a new icon system.
    return (
        <Scene7Image
            testId="legacy-icon"
            src={iconSrc}
            alt={`icon ${name}`}
            className={className}
            loading={isPriority ? 'eager' : 'lazy'}
            width={size}
        />
    );
}
